/**
 * Generated by orval v8.9.1 🍺
 * Do not edit manually.
 * Praetoid Dashboard API
 * OpenAPI spec version: 1.0
 */
import * as zod from 'zod';

export const ReasoningStep = zod.union([
	zod
		.object({
			args_digest: zod.looseObject({}).nullable().describe('Truncated tool arguments'),
			duration_ms: zod.number().describe('Duration in milliseconds'),
			finished_at: zod.iso.datetime({ offset: true }).describe('Step finish timestamp'),
			index: zod.number().describe('Step index within the trace'),
			kind: zod.enum(['tool_call']),
			outcome: zod.enum(['ok', 'validation_error', 'error']),
			rationale: zod.string().nullable().describe('Agent rationale for this step'),
			result_digest: zod.string().nullable().describe('Truncated tool result'),
			started_at: zod.iso.datetime({ offset: true }).describe('Step start timestamp'),
			tool: zod.string().describe('Tool name'),
			tool_version: zod.string().nullable().describe('Tool version')
		})
		.describe('A tool invocation in the reasoning trace'),
	zod
		.object({
			duration_ms: zod.number().describe('Duration in milliseconds'),
			finished_at: zod.iso.datetime({ offset: true }).describe('Step finish timestamp'),
			index: zod.number().describe('Step index within the trace'),
			kind: zod.enum(['llm_turn']),
			rationale: zod.string().nullable().describe('Agent rationale for this step'),
			started_at: zod.iso.datetime({ offset: true }).describe('Step start timestamp')
		})
		.describe('An LLM turn in the reasoning trace'),
	zod
		.object({
			confidence: zod.number().describe('Final confidence score'),
			content_decision: zod.enum(['allow', 'review', 'block']),
			index: zod.number().describe('Step index within the trace'),
			kind: zod.enum(['final_judgement']),
			rationale: zod.string().nullable().describe('Agent rationale for this step')
		})
		.describe('The final judgement in the reasoning trace')
]);

export type ReasoningStep = zod.input<typeof ReasoningStep>;
export type ReasoningStepOutput = zod.output<typeof ReasoningStep>;
